exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".diabled-dropdown{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: gray;\n    top :0px;\n    opacity: 0.3;\n}", "", {"version":3,"sources":["/home/dev/feildforce/client/app/utilities/addcampaign/addcampaign.component.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,aAAa;CAChB","file":"addcampaign.component.css","sourcesContent":[".diabled-dropdown{\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    background-color: gray;\n    top :0px;\n    opacity: 0.3;\n}"],"sourceRoot":""}]);

// exports
